var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 53,
    viewBox: "0 0 49 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5355 23.2617C40.0647 26.4706 40.6984 30.033 40.3697 33.5723C40.0409 37.1117 38.7619 40.4964 36.6678 43.3687C34.5737 46.241 31.7424 48.494 28.4732 49.8896C25.2041 51.2852 21.6186 51.7715 18.0958 51.2971C14.573 50.8227 11.2438 49.4052 8.46036 47.1944C5.67688 44.9837 3.54249 42.0619 2.28286 38.738C1.02324 35.4141 0.68519 31.8116 1.30446 28.3113C1.92373 24.8111 3.47731 21.5432 5.80093 18.8533",
    fill: "#DFE33D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5355 23.2617C40.0647 26.4706 40.6984 30.033 40.3697 33.5723C40.0409 37.1117 38.7619 40.4964 36.6678 43.3687C34.5737 46.241 31.7424 48.494 28.4732 49.8896C25.2041 51.2852 21.6186 51.7715 18.0958 51.2971C14.573 50.8227 11.2438 49.4052 8.46036 47.1944C5.67688 44.9837 3.54249 42.0619 2.28286 38.738C1.02324 35.4141 0.68519 31.8116 1.30446 28.3113C1.92373 24.8111 3.47731 21.5432 5.80093 18.8533",
    stroke: "#005D5F",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4943 12.4814C21.0489 11.4872 25.8082 12.132 29.9341 14.3022",
    stroke: "#005D5F",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.629 16.9626C30.3488 16.9778 30.192 16.9819 30.192 16.9819C30.192 16.9819 29.5426 8.65054 32.9142 4.92086C36.2858 1.19119 44.6414 1 44.6414 1C44.6414 1 45.2908 9.33133 41.9182 13.061C41.7265 13.2725 41.5218 13.4719 41.3052 13.6578",
    fill: "#DFE33D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.629 16.9626C30.3488 16.9778 30.192 16.9819 30.192 16.9819C30.192 16.9819 29.5426 8.65054 32.9142 4.92086C36.2858 1.19119 44.6414 1 44.6414 1C44.6414 1 45.2908 9.33133 41.9182 13.061C41.7265 13.2725 41.5218 13.4719 41.3052 13.6578",
    stroke: "#005D5F",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4105 13.409C35.4229 12.9416 30.3063 17.2206 30.3063 17.2206C30.3063 17.2206 34.297 22.5688 38.2846 23.0361C42.2723 23.5035 47.3888 19.2235 47.3888 19.2235C47.3888 19.2235 43.3981 13.8763 39.4105 13.409Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53783 30.0656C7.43207 29.7507 7.38937 29.4182 7.41215 29.0868C7.43493 28.7555 7.52276 28.4319 7.67061 28.1345C7.81846 27.8371 8.02345 27.5717 8.27386 27.3535C8.52427 27.1354 8.8152 26.9687 9.13005 26.8629",
    stroke: "#005D5F",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9815 43.4224C13.6667 43.5282 13.3341 43.5709 13.0028 43.5481C12.6714 43.5253 12.3478 43.4375 12.0504 43.2896C11.753 43.1418 11.4877 42.9368 11.2695 42.6864C11.0513 42.436 10.8846 42.145 10.7789 41.8302",
    stroke: "#005D5F",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7469 40.2724C29.7681 40.6038 29.7237 40.9362 29.6164 41.2505C29.5091 41.5648 29.3409 41.8548 29.1215 42.1041C28.902 42.3534 28.6356 42.5571 28.3375 42.7034C28.0394 42.8498 27.7153 42.936 27.3839 42.9571",
    stroke: "#005D5F",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58681 19.1072C12.7769 19.1072 16.1736 15.7105 16.1736 11.5204C16.1736 7.33029 12.7769 3.93356 8.58681 3.93356C4.39673 3.93356 1 7.33029 1 11.5204C1 15.7105 4.39673 19.1072 8.58681 19.1072Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87908 15.0609H15.2946Z",
    fill: "#DFE33D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87908 15.0609H15.2946",
    stroke: "#005D5F",
    strokeWidth: 1.81,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2946 7.97986H1.87908Z",
    fill: "#DFE33D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2946 7.97986H1.87908",
    stroke: "#005D5F",
    strokeWidth: 1.81,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.c661ffbc2027b50dbecb29118045117a.svg";
export { ForwardRef as ReactComponent };